<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" #treeCmp [ngClass]="isRootExpanded ? 'expanded-tree': 'collapsed-tree'">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <a [routerLink]="[node.url]" [queryParams]="queryParams" [ngClass]="{'cat-active':  node['id'] == currentGroup.id}">
            <span (click)="treeNodeSelected($event, node)">
                <span closeComponent [innerHTML]="node.name | safe: 'html'"></span>
                <span class="amount" dir="ltr">({{node.count}})</span>
            </span>
        </a>
    </mat-tree-node>

    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <a [routerLink]="[node.url]" [queryParams]="queryParams" [ngClass]="{'cat-active':  node['id'] == currentGroup.id}">
            <span (click)="treeNodeSelected($event, node)">
                <span closeComponent [innerHTML]="node.name | safe: 'html'"></span>
                <span class="amount" dir="ltr">({{node.count}})</span>
            </span>
        </a>
        <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
                {{node.level === 0 ? (treeControl.isExpanded(node) ? 'clear' : 'menu'):
                (treeControl.isExpanded(node) ?'expand_more' : 'keyboard_arrow_up') }}
            </mat-icon>
        </button>
    </mat-tree-node>
</mat-tree>

<div [ngClass]="isRootExpanded ? 'expanded-tree-bottom-content': 'collapsed-tree-bottom-content'">
    <ng-content select="[treeViewBottomContent]"></ng-content>
</div>
